/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @interface SearchFilterAttributeTargetVOAllOf
 */
export interface SearchFilterAttributeTargetVOAllOf {
    /**
     * Vrstva, na které atribut je. Filtr mapového enginu se aplikuje podle `atributName` (podmínky enginu jsou vedené názvem atributu, ne ID vrstvy); `layerId` slouží pro serverové dohledání objektů a pro řízení viditelnosti vrstev.
     * @type {number}
     * @memberof SearchFilterAttributeTargetVOAllOf
     */
    'layerId': number;
    /**
     * Název atributu vrstvy, na který se podmínka aplikuje.
     * @type {string}
     * @memberof SearchFilterAttributeTargetVOAllOf
     */
    'atributName': string;
    /**
     * Typ hodnoty – určuje typ engine podmínky.
     * @type {string}
     * @memberof SearchFilterAttributeTargetVOAllOf
     */
    'valueType': SearchFilterAttributeTargetVOAllOfValueTypeEnum;
    /**
     * Hodnoty (kódy číselníku); v rámci jednoho listu se OR-ují.
     * @type {Array<string>}
     * @memberof SearchFilterAttributeTargetVOAllOf
     */
    'values': Array<string>;
}

export const SearchFilterAttributeTargetVOAllOfValueTypeEnum = {
    STRING: 'string',
    INTEGER: 'integer'
} as const;

export type SearchFilterAttributeTargetVOAllOfValueTypeEnum = typeof SearchFilterAttributeTargetVOAllOfValueTypeEnum[keyof typeof SearchFilterAttributeTargetVOAllOfValueTypeEnum];


